import React, { useContext, useEffect, useState } from 'react'
import styles from './LbGsCreateForm.module.css'
import { motion } from 'framer-motion'
import Select from 'react-select'
import { Link } from 'react-router-dom' // Fix: should be from react-router-dom
import { useNavigate } from 'react-router'
import { FaSpinner } from 'react-icons/fa6'
import { BASE_URL_API } from '../../References/URLs'
import AuthContext from '../../store/auth-context'
import ActiveStoreContext from '../../store/ActiveStoreContext'
import { toast } from 'react-toastify'

const LbGsCreateForm = () => {
    const authCtx = useContext(AuthContext);
    const asCtx = useContext(ActiveStoreContext);
    const activeStore = (() => {
        try {
            return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null;
        } catch {
            return null;
        }
    })();

    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier

    const [selectedDomain, setSelectedDomain] = useState(null)
    const [formName, setFormName] = useState('')
    const [webPageUrl, setWebPageUrl] = useState('')
    const [token, setToken] = useState('')
    const [loading, setLoading] = useState(false)
    const [showDomainInput, setShowDomainInput] = useState(false)
    const [customDomain, setCustomDomain] = useState('')
    const nav = useNavigate()
    const [domains, setDomains] = useState([
        { domainIdentifier: '', domain: 'Loading...' },
    ])

    const domainOptions = domains.map(d => ({
        value: d.domain,
        label: d.domain
    }))

    domainOptions.push({ value: 'new', label: '+ Add New Domain' })

    const handleDomainChange = (option) => {
        if (option?.value === 'new') {
            nav(`/leadbridge/get-started/add-domain`)
        } else {
            setShowDomainInput(true)
            setSelectedDomain(option)
        }
    }

    const lb_getDomains = async () => {
        const payload = JSON.stringify({
            token : authCtx.token,
            vendorIdentifier : vendorIdentifier,
            storeIdentifier : activeStore.storeIdentifier
        });
        const createDomainResponse = await fetch(BASE_URL_API+"lb_getDomains",
        {
            method : "POST",
            body : payload
        });

        if(!createDomainResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const createDomainRespo = await createDomainResponse.json()
            if(createDomainRespo.status==="success") {
                setDomains(createDomainRespo?.response)
            } else {
                if(createDomainRespo.message==="tokenExpired") {
                    authCtx.logout()
                } else {

                }
                setDomains([])
                console.log(createDomainRespo)
            }
        }

    }

    useEffect(() => {
        lb_getDomains()
    }, [])
    


    const handleGenerateToken = async () => {
        const domainValue = !showDomainInput ? customDomain : selectedDomain?.value

        if (!formName || !domainValue) return alert("Please enter form name and select domain.")

        setLoading(true)

        const lb_generateFormToken = await fetch(BASE_URL_API+"lb_generateFormToken",
        {
            method : "POST",
            body : JSON.stringify({
                token : authCtx.token,
                storeIdentifier : activeStore?.storeIdentifier,
                vendorIdentifier : vendorIdentifier,
                domain : domainValue,
                webPageUrl : webPageUrl,
                formName : formName,
                formDetails : '',
                authIdentifier : authCtx.authIdentifier
            })
        });

        if(!lb_generateFormToken.ok) {
            console.log("Something went wrong : Server Error");
        } else {
            const lb_generateFormTokenResponse = await lb_generateFormToken.json()
            if(lb_generateFormTokenResponse.status==="success") {
                toast.success(`Token successfully generated!`);
                nav(`/leadbridge/view-token/${lb_generateFormTokenResponse?.response}`)
            } else {
                if(lb_generateFormTokenResponse.message==="tokenExpired") {
                    authCtx.logout()
                }

            }
            console.log(lb_generateFormTokenResponse)
        }
        setLoading(false)
    }

    if (activeStore === null) {
        return (
            <div className={styles.mainWrapper}>
                <div className={styles.mainContainer}>
                    <div className={styles.mainContent}>
                        Please select a store!
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.createFormContainer}>
            <div className={styles.pageHeader}>
                <Link to={`/leadbridge`} className={styles.phlWrapper}>
                    LeadBridge™
                </Link>
                <div className={styles.phrWrapper}>
                    <Link to={`/leadbridge/dashboard`}>
                        Go To Dashboard
                    </Link>
                    <Link to={`/leadbridge/help`}>
                        Help
                    </Link>
                </div>
            </div>
            <div className={styles.pageBody}>
                <motion.div
                    className={styles.content}
                    initial={{ opacity: 0, y: 60 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <div className={styles.formHeader}>
                        <h2>Create a Form</h2>
                        <p>Link a domain and give your form a memorable name.</p>
                    </div>
                    <div className={styles.fieldWrapper}>
                        <div className={styles.oneInARow} >
                            <div className={styles.inputGroup}>
                                <label>Select Domain</label>
                                <Select
                                    className={styles.selectDropdown}
                                    options={domainOptions}
                                    value={selectedDomain}
                                    onChange={handleDomainChange}
                                    placeholder="Select or search domain"
                                    isSearchable
                                    autoFocus
                                />
                            </div>
                        </div>

                        {showDomainInput &&
                            <div className={styles.twoInARow}>
                                <div className={styles.inputGroup}>
                                    <label>Form Name</label>
                                    <input
                                        type="text"
                                        placeholder="Enter form name (e.g. contact_form)"
                                        value={formName}
                                        onChange={(e) => setFormName(e.target.value)}
                                        autoFocus
                                    />
                                </div>

                                <div className={styles.inputGroup}>
                                    <label>Web Page URL (Optional)</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the URL where the form will be placed"
                                        value={webPageUrl}
                                        onChange={(e) => setWebPageUrl(e.target.value)}
                                    />
                                </div>
                            </div>
                        }
                    </div>

                    {showDomainInput &&
                        <div>
                            {loading ?
                                <button className={styles.generateBtn} onClick={handleGenerateToken} disabled={loading}>
                                    <FaSpinner className={styles.spinner} /> Generating Token...
                                </button>
                                :
                                <button className={styles.generateBtn} onClick={handleGenerateToken} disabled={loading}>
                                    Generate Token
                                </button>
                            }
                        </div>
                    }

                </motion.div>
                {token && (
                    <div className={styles.tokenBoxWrapper}>
                        <div className={styles.tokenBox}>
                            <p><strong>Generated Token:</strong></p>
                            <code>{token}</code>
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.stickyNav}>
                <Link to={`/leadbridge/get-started/add-domain`} className={styles.secondaryBtn}>← Previous</Link>
                {/* <Link to={`/leadbridge/get-started/go-to-dashboard`} className={styles.primaryBtn}>Next →</Link> */}
            </div>
        </div>
    )
}

export default LbGsCreateForm
